/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'

// Create Virtual Routes

const VaultcampLazyImport = createFileRoute('/vaultcamp')()
const VaultLazyImport = createFileRoute('/vault')()
const TermsLazyImport = createFileRoute('/terms')()
const SwapLazyImport = createFileRoute('/swap')()
const RewardsLazyImport = createFileRoute('/rewards')()
const PrivacyLazyImport = createFileRoute('/privacy')()
const OverviewLazyImport = createFileRoute('/overview')()
const FaqLazyImport = createFileRoute('/faq')()
const ExploreLazyImport = createFileRoute('/explore')()
const EarnLazyImport = createFileRoute('/earn')()
const BorrowLazyImport = createFileRoute('/borrow')()
const AboutLazyImport = createFileRoute('/about')()
const IndexLazyImport = createFileRoute('/')()
const MarketIndexLazyImport = createFileRoute('/market/')()
const FeatureMusdLazyImport = createFileRoute('/feature/musd')()
const FeatureGrowthLazyImport = createFileRoute('/feature/growth')()
const FeatureBorrowLazyImport = createFileRoute('/feature/borrow')()
const MarketItemsMarketItemIdLazyImport = createFileRoute(
  '/market/items/$marketItemId',
)()

// Create/Update Routes

const VaultcampLazyRoute = VaultcampLazyImport.update({
  id: '/vaultcamp',
  path: '/vaultcamp',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/vaultcamp.lazy').then((d) => d.Route))

const VaultLazyRoute = VaultLazyImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/vault.lazy').then((d) => d.Route))

const TermsLazyRoute = TermsLazyImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))

const SwapLazyRoute = SwapLazyImport.update({
  id: '/swap',
  path: '/swap',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/swap.lazy').then((d) => d.Route))

const RewardsLazyRoute = RewardsLazyImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rewards.lazy').then((d) => d.Route))

const PrivacyLazyRoute = PrivacyLazyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/privacy.lazy').then((d) => d.Route))

const OverviewLazyRoute = OverviewLazyImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/overview.lazy').then((d) => d.Route))

const FaqLazyRoute = FaqLazyImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/faq.lazy').then((d) => d.Route))

const ExploreLazyRoute = ExploreLazyImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/explore.lazy').then((d) => d.Route))

const EarnLazyRoute = EarnLazyImport.update({
  id: '/earn',
  path: '/earn',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/earn.lazy').then((d) => d.Route))

const BorrowLazyRoute = BorrowLazyImport.update({
  id: '/borrow',
  path: '/borrow',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/borrow.lazy').then((d) => d.Route))

const AboutLazyRoute = AboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const MarketIndexLazyRoute = MarketIndexLazyImport.update({
  id: '/market/',
  path: '/market/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/market/index.lazy').then((d) => d.Route))

const FeatureMusdLazyRoute = FeatureMusdLazyImport.update({
  id: '/feature/musd',
  path: '/feature/musd',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/feature/musd.lazy').then((d) => d.Route))

const FeatureGrowthLazyRoute = FeatureGrowthLazyImport.update({
  id: '/feature/growth',
  path: '/feature/growth',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/feature/growth.lazy').then((d) => d.Route),
)

const FeatureBorrowLazyRoute = FeatureBorrowLazyImport.update({
  id: '/feature/borrow',
  path: '/feature/borrow',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/feature/borrow.lazy').then((d) => d.Route),
)

const MarketItemsMarketItemIdLazyRoute =
  MarketItemsMarketItemIdLazyImport.update({
    id: '/market/items/$marketItemId',
    path: '/market/items/$marketItemId',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/market/items.$marketItemId.lazy').then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/borrow': {
      id: '/borrow'
      path: '/borrow'
      fullPath: '/borrow'
      preLoaderRoute: typeof BorrowLazyImport
      parentRoute: typeof rootRoute
    }
    '/earn': {
      id: '/earn'
      path: '/earn'
      fullPath: '/earn'
      preLoaderRoute: typeof EarnLazyImport
      parentRoute: typeof rootRoute
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreLazyImport
      parentRoute: typeof rootRoute
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqLazyImport
      parentRoute: typeof rootRoute
    }
    '/overview': {
      id: '/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof OverviewLazyImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyLazyImport
      parentRoute: typeof rootRoute
    }
    '/rewards': {
      id: '/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof RewardsLazyImport
      parentRoute: typeof rootRoute
    }
    '/swap': {
      id: '/swap'
      path: '/swap'
      fullPath: '/swap'
      preLoaderRoute: typeof SwapLazyImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsLazyImport
      parentRoute: typeof rootRoute
    }
    '/vault': {
      id: '/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof VaultLazyImport
      parentRoute: typeof rootRoute
    }
    '/vaultcamp': {
      id: '/vaultcamp'
      path: '/vaultcamp'
      fullPath: '/vaultcamp'
      preLoaderRoute: typeof VaultcampLazyImport
      parentRoute: typeof rootRoute
    }
    '/feature/borrow': {
      id: '/feature/borrow'
      path: '/feature/borrow'
      fullPath: '/feature/borrow'
      preLoaderRoute: typeof FeatureBorrowLazyImport
      parentRoute: typeof rootRoute
    }
    '/feature/growth': {
      id: '/feature/growth'
      path: '/feature/growth'
      fullPath: '/feature/growth'
      preLoaderRoute: typeof FeatureGrowthLazyImport
      parentRoute: typeof rootRoute
    }
    '/feature/musd': {
      id: '/feature/musd'
      path: '/feature/musd'
      fullPath: '/feature/musd'
      preLoaderRoute: typeof FeatureMusdLazyImport
      parentRoute: typeof rootRoute
    }
    '/market/': {
      id: '/market/'
      path: '/market'
      fullPath: '/market'
      preLoaderRoute: typeof MarketIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/market/items/$marketItemId': {
      id: '/market/items/$marketItemId'
      path: '/market/items/$marketItemId'
      fullPath: '/market/items/$marketItemId'
      preLoaderRoute: typeof MarketItemsMarketItemIdLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/borrow': typeof BorrowLazyRoute
  '/earn': typeof EarnLazyRoute
  '/explore': typeof ExploreLazyRoute
  '/faq': typeof FaqLazyRoute
  '/overview': typeof OverviewLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/swap': typeof SwapLazyRoute
  '/terms': typeof TermsLazyRoute
  '/vault': typeof VaultLazyRoute
  '/vaultcamp': typeof VaultcampLazyRoute
  '/feature/borrow': typeof FeatureBorrowLazyRoute
  '/feature/growth': typeof FeatureGrowthLazyRoute
  '/feature/musd': typeof FeatureMusdLazyRoute
  '/market': typeof MarketIndexLazyRoute
  '/market/items/$marketItemId': typeof MarketItemsMarketItemIdLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/borrow': typeof BorrowLazyRoute
  '/earn': typeof EarnLazyRoute
  '/explore': typeof ExploreLazyRoute
  '/faq': typeof FaqLazyRoute
  '/overview': typeof OverviewLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/swap': typeof SwapLazyRoute
  '/terms': typeof TermsLazyRoute
  '/vault': typeof VaultLazyRoute
  '/vaultcamp': typeof VaultcampLazyRoute
  '/feature/borrow': typeof FeatureBorrowLazyRoute
  '/feature/growth': typeof FeatureGrowthLazyRoute
  '/feature/musd': typeof FeatureMusdLazyRoute
  '/market': typeof MarketIndexLazyRoute
  '/market/items/$marketItemId': typeof MarketItemsMarketItemIdLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/borrow': typeof BorrowLazyRoute
  '/earn': typeof EarnLazyRoute
  '/explore': typeof ExploreLazyRoute
  '/faq': typeof FaqLazyRoute
  '/overview': typeof OverviewLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/swap': typeof SwapLazyRoute
  '/terms': typeof TermsLazyRoute
  '/vault': typeof VaultLazyRoute
  '/vaultcamp': typeof VaultcampLazyRoute
  '/feature/borrow': typeof FeatureBorrowLazyRoute
  '/feature/growth': typeof FeatureGrowthLazyRoute
  '/feature/musd': typeof FeatureMusdLazyRoute
  '/market/': typeof MarketIndexLazyRoute
  '/market/items/$marketItemId': typeof MarketItemsMarketItemIdLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/borrow'
    | '/earn'
    | '/explore'
    | '/faq'
    | '/overview'
    | '/privacy'
    | '/rewards'
    | '/swap'
    | '/terms'
    | '/vault'
    | '/vaultcamp'
    | '/feature/borrow'
    | '/feature/growth'
    | '/feature/musd'
    | '/market'
    | '/market/items/$marketItemId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/borrow'
    | '/earn'
    | '/explore'
    | '/faq'
    | '/overview'
    | '/privacy'
    | '/rewards'
    | '/swap'
    | '/terms'
    | '/vault'
    | '/vaultcamp'
    | '/feature/borrow'
    | '/feature/growth'
    | '/feature/musd'
    | '/market'
    | '/market/items/$marketItemId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/borrow'
    | '/earn'
    | '/explore'
    | '/faq'
    | '/overview'
    | '/privacy'
    | '/rewards'
    | '/swap'
    | '/terms'
    | '/vault'
    | '/vaultcamp'
    | '/feature/borrow'
    | '/feature/growth'
    | '/feature/musd'
    | '/market/'
    | '/market/items/$marketItemId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AboutLazyRoute: typeof AboutLazyRoute
  BorrowLazyRoute: typeof BorrowLazyRoute
  EarnLazyRoute: typeof EarnLazyRoute
  ExploreLazyRoute: typeof ExploreLazyRoute
  FaqLazyRoute: typeof FaqLazyRoute
  OverviewLazyRoute: typeof OverviewLazyRoute
  PrivacyLazyRoute: typeof PrivacyLazyRoute
  RewardsLazyRoute: typeof RewardsLazyRoute
  SwapLazyRoute: typeof SwapLazyRoute
  TermsLazyRoute: typeof TermsLazyRoute
  VaultLazyRoute: typeof VaultLazyRoute
  VaultcampLazyRoute: typeof VaultcampLazyRoute
  FeatureBorrowLazyRoute: typeof FeatureBorrowLazyRoute
  FeatureGrowthLazyRoute: typeof FeatureGrowthLazyRoute
  FeatureMusdLazyRoute: typeof FeatureMusdLazyRoute
  MarketIndexLazyRoute: typeof MarketIndexLazyRoute
  MarketItemsMarketItemIdLazyRoute: typeof MarketItemsMarketItemIdLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AboutLazyRoute: AboutLazyRoute,
  BorrowLazyRoute: BorrowLazyRoute,
  EarnLazyRoute: EarnLazyRoute,
  ExploreLazyRoute: ExploreLazyRoute,
  FaqLazyRoute: FaqLazyRoute,
  OverviewLazyRoute: OverviewLazyRoute,
  PrivacyLazyRoute: PrivacyLazyRoute,
  RewardsLazyRoute: RewardsLazyRoute,
  SwapLazyRoute: SwapLazyRoute,
  TermsLazyRoute: TermsLazyRoute,
  VaultLazyRoute: VaultLazyRoute,
  VaultcampLazyRoute: VaultcampLazyRoute,
  FeatureBorrowLazyRoute: FeatureBorrowLazyRoute,
  FeatureGrowthLazyRoute: FeatureGrowthLazyRoute,
  FeatureMusdLazyRoute: FeatureMusdLazyRoute,
  MarketIndexLazyRoute: MarketIndexLazyRoute,
  MarketItemsMarketItemIdLazyRoute: MarketItemsMarketItemIdLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/borrow",
        "/earn",
        "/explore",
        "/faq",
        "/overview",
        "/privacy",
        "/rewards",
        "/swap",
        "/terms",
        "/vault",
        "/vaultcamp",
        "/feature/borrow",
        "/feature/growth",
        "/feature/musd",
        "/market/",
        "/market/items/$marketItemId"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/borrow": {
      "filePath": "borrow.lazy.tsx"
    },
    "/earn": {
      "filePath": "earn.lazy.tsx"
    },
    "/explore": {
      "filePath": "explore.lazy.tsx"
    },
    "/faq": {
      "filePath": "faq.lazy.tsx"
    },
    "/overview": {
      "filePath": "overview.lazy.tsx"
    },
    "/privacy": {
      "filePath": "privacy.lazy.tsx"
    },
    "/rewards": {
      "filePath": "rewards.lazy.tsx"
    },
    "/swap": {
      "filePath": "swap.lazy.tsx"
    },
    "/terms": {
      "filePath": "terms.lazy.tsx"
    },
    "/vault": {
      "filePath": "vault.lazy.tsx"
    },
    "/vaultcamp": {
      "filePath": "vaultcamp.lazy.tsx"
    },
    "/feature/borrow": {
      "filePath": "feature/borrow.lazy.tsx"
    },
    "/feature/growth": {
      "filePath": "feature/growth.lazy.tsx"
    },
    "/feature/musd": {
      "filePath": "feature/musd.lazy.tsx"
    },
    "/market/": {
      "filePath": "market/index.lazy.tsx"
    },
    "/market/items/$marketItemId": {
      "filePath": "market/items.$marketItemId.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
